<template>
  <modal :show.sync="show" modalClasses="modal-hide-footer">
    <h3 slot="header" class="mb-0 font-weight-500">Past Enquiry Details</h3>
    <b-row>
      <b-col cols="12">
        <!-- Banks -->
        <b-table bordered small :items="[fi]" :fields="fiFields" responsive="sm">
          <template #thead-top>
            <tr class="bg-light font-weight-bold">
              <th colspan="4">Enquiry(ies) in the Past 12 Months (Banks)</th>
            </tr>
          </template>
        </b-table>

        <!-- Non-Banks -->
        <b-table bordered small :items="[nonFi]" :fields="fiFields" responsive="sm">
          <template #thead-top>
            <tr class="bg-light font-weight-bold">
              <th colspan="4">Enquiry(ies) in the Past 12 Months (Non-Banks)</th>
            </tr>
          </template>
        </b-table>

        <!-- Current Enquiry -->
        <b-table bordered small :items="currentItems" :fields="currentFields" responsive="sm">
          <template #thead-top>
            <tr class="bg-light font-weight-bold">
              <th colspan="3">Current enquiry</th>
            </tr>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </modal>
</template>

<script>
import Modal from "@/components/Modal";
import { Table, TableColumn } from "element-ui";

export default {
  name: "PastEnquiryModal",
  props: {
    show_past_enquiry_full_view: Boolean,
    fi: { type: Object, required: true },
    nonFi: { type: Object, required: true },
    reqNo: { type: String, required: true },
    userId: { type: String, required: true }
  },
  components: {
    Modal,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
 computed: {
  show: {
    get() {
      return this.show_past_enquiry_full_view;
    },
    set(value) {
      this.$emit("update:show_past_enquiry_full_view", value);
    }
  },
  fiFields() {
    return [
      { key: 'EnqDate', label: 'Enquiry Date/Time' },
      { key: 'EnqNo', label: 'Enquiry Number' },
      { key: 'Purpose', label: 'Enquiry Type' },
      { key: 'Enquirer', label: 'Enquirer ID' }
    ]
  },
  currentFields() {
    return [
      { key: 'reqNo', label: 'Enquiry Number' },
      { key: 'reportType', label: 'Report Enquiry Type' },
      { key: 'userId', label: 'Enquirer ID' }
    ]
  },
  currentItems() {
    return [
      {
        reqNo: this.reqNo,
        reportType: '', // add value if API returns
        userId: this.userId
      }
    ]
  }
}

};
</script>